import { formatPrice } from "FrontendJsAssets/common/format";

const updatingAccessories = {}
$(function () {
    $('.js-cart-accessory-input').on('change', function () {
        const rowEl = this.closest('.js-cart-product-row');
        const $row = $(this).closest('.js-cart-product-row');
        const productId = $row.data('cartId');
        const quantity = $(this).data('quantity')
        const accessoryId = $(this).val();
        const price = $(this).data('price');
        const value = $(this).val();

        const totalPriceEl = rowEl.querySelector('.js-accessory-total-price');
        const spinnerEl = rowEl.querySelector('.js-accessory-spinner');

        spinnerEl.classList.add('is-active')

        if (updatingAccessories[productId]) {
            updatingAccessories[productId].abort();
        }

        updatingAccessories[productId] = $.post('/change-variation-accessory', { product_id: productId, accessory_id: accessoryId, quantity: quantity || 1 }, function (data) {
            Eshop.alert(data.message, { type: data.status ? 'success' : 'error' });

            if (data.status) {
                Cart.updates.totals(data.total);

                const productCartQuantity = totalPriceEl.dataset.productCartQuantity

                totalPriceEl.dataset.singularPrice = price;

                totalPriceEl.innerHTML = value !== '0'
                    ? formatPrice(productCartQuantity * price)
                    : ''
            }
        }, "json")
            .fail(function (data) {
                Eshop.alert(data.responseJSON.message, { type: 'error' });
            })
            .always(function () {
                spinnerEl.classList.remove('is-active')

                delete updatingAccessories[productId]
            });
    });
});